if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        // Reserve flow: show confirmation modal before adding to cart
        if (
          submitButton.classList.contains("reserve-btn") &&
          !this._reserveConfirmed
        ) {
          this.showReserveModal(submitButton);
          return;
        }
        this._reserveConfirmed = false;

        const isReserve = submitButton.classList.contains("reserve-btn");

        // Check for cart conflicts before adding
        this.handleErrorMessage();
        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        fetch("/cart.js")
          .then((r) => r.json())
          .then((cart) => {
            if (cart.items && cart.items.length > 0) {
              const cartHasReservation = cart.items.some(
                (item) =>
                  item.properties && item.properties._reservation === "true",
              );
              const cartHasRegular = cart.items.some(
                (item) =>
                  !item.properties || item.properties._reservation !== "true",
              );

              if (isReserve && cartHasRegular) {
                this.handleErrorMessage(
                  "Reservations must be placed as a separate order. Please complete your current order first, then come back to reserve.",
                );
                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
                return;
              }
              if (!isReserve && cartHasReservation) {
                this.handleErrorMessage(
                  "Your cart contains a reservation. Please complete that order first, then come back to purchase in-stock items.",
                );
                submitButton.classList.remove("loading");
                submitButton.removeAttribute("aria-disabled");
                return;
              }
            }

            this.addToCart(submitButton, isReserve);
          })
          .catch(() => {
            // If cart check fails, proceed with add anyway
            this.addToCart(submitButton, isReserve);
          });
      }

      addToCart(submitButton, isReserve) {
        this.cartNotification.setActiveElement(document.activeElement);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Add reservation line item properties
        if (isReserve) {
          formData.append("properties[_reservation]", "true");
          formData.append(
            "properties[Reservation]",
            "Ships when inventory arrives",
          );
        }

        formData.append(
          "sections",
          this.cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.querySelector(".wbquicksuccess").classList.add("hidden");
              this.handleErrorMessage(response.description);
              return;
            }

            window.location.href = "/cart";
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
          });
      }

      showReserveModal(submitButton) {
        const section = this.closest("section");
        if (!section) return;
        const sectionId = section.querySelector(
          "variant-radios, variant-selects",
        )?.dataset.section;
        const modal = document.getElementById(`reserve-modal-${sectionId}`);
        if (!modal) return;

        modal.style.display = "flex";

        const backdrop = modal.querySelector(".reserve-modal__backdrop");
        const cancelBtn = modal.querySelector(".reserve-modal__cancel");
        const confirmBtn = modal.querySelector(".reserve-modal__confirm");

        const closeModal = () => {
          modal.style.display = "none";
          backdrop.removeEventListener("click", closeModal);
          cancelBtn.removeEventListener("click", closeModal);
          confirmBtn.removeEventListener("click", onConfirm);
          document.removeEventListener("keydown", onEscape);
        };

        const onConfirm = () => {
          closeModal();
          this._reserveConfirmed = true;
          this.form.requestSubmit(submitButton);
        };

        const onEscape = (e) => {
          if (e.key === "Escape") closeModal();
        };

        backdrop.addEventListener("click", closeModal);
        cancelBtn.addEventListener("click", closeModal);
        confirmBtn.addEventListener("click", onConfirm);
        document.addEventListener("keydown", onEscape);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
